// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__eJRbR","newExpiryDate":"styles_newExpiryDate__4SrPE","footer":"styles_footer__2FIPZ"};